import { useMutation, useQueryClient } from 'react-query'
import { QueryNames } from 'Hooks/api/queryNames'
import { toast } from 'react-toastify'
import { addRecurringAllowance } from 'Services/recurringAllowances'

export const useAddUserRecurringAllowanceMutation = () => {
  const queryClient = useQueryClient()

  return useMutation([QueryNames.AddUserRecurringAllowance], addRecurringAllowance, {
    onSuccess: (response) => {
      if (response.success) {
        // Invalidate all recurring allowances queries
        queryClient.invalidateQueries([QueryNames.GetUserRecurringAllowances])
        toast.success('Recurring allowance created successfully')
      } else {
        toast.error(`Failed to create recurring allowance: ${response.message}`)
      }
    },
    onError: (error: any) => {
      console.error('Recurring allowance creation error:', error)
      toast.error('Failed to create recurring allowance')
    }
  })
}
